export default __webpack_public_path__ + "static/media/telegram-logo.fa0440d0.png";